import { render } from "./DashboardColumn.vue?vue&type=template&id=1c12c389&scoped=true"
import script from "./DashboardColumn.vue?vue&type=script&lang=js"
export * from "./DashboardColumn.vue?vue&type=script&lang=js"

import "./DashboardColumn.vue?vue&type=style&index=0&id=1c12c389&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c12c389"]])

export default __exports__